import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement, useSyncExternalStore } from 'react';
import { tokens } from '@synergy/theme-palo';

import { createPaloSlot } from '../../../common/components/palo/palo-positions-slot';
import { useAppSelector } from '../../../store/use-appstate-selector';

const dispatch = createPaloSlot();

/**
 * The place at the top of the suppliers tab where the dispatch list is drawn:
 * who gets the inquiry, above the search for more (#2258).
 */
export const InquiryDispatchSlotProvider = dispatch.Provider;
export const InquiryDispatchSlot = dispatch.Slot;
export const InquiryInDispatchSlot = dispatch.In;

/*
 * How many suppliers the dispatch list holds, for the tab's name. Held here
 * rather than read from the saved inquiry, so the figure moves with every tick
 * in the search and not only after saving.
 */
let picked = 0;
const listeners = new Set<() => void>();

export const setInquiryPickedSupplierCount = (count: number): void => {
    if (count !== picked) {
        picked = count;
        listeners.forEach(listener => listener());
    }
};

const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => listeners.delete(listener);
};

/** "Lieferanten & Versand 2". */
export const InquirySuppliersTabName = (): ReactElement => {
    const live = useSyncExternalStore(subscribe, () => picked);
    // Seen from another tab, the list is not drawn: the saved figure stands in.
    const saved = useAppSelector(state => state.inquiries.entity?.supplierAccounts?.length ?? 0);
    const count = live || saved;

    return (
        <>
            <FormattedMessage id="app.inquiries.detail.step.suppliersAndDispatch" />
            {count > 0 && (
                <Box component="span" sx={{ color: tokens.color.ink3, fontWeight: 400, marginLeft: '5px' }}>
                    {count}
                </Box>
            )}
        </>
    );
};

/*
 * The offers tab, for the link from an offer in the dispatch list. The
 * inquiry mask registers how to get there; the list only asks for it.
 */
let openOffers: (() => void) | undefined;

export const setInquiryOpenOffers = (open?: () => void): void => {
    openOffers = open;
};

export const openInquiryOffers = (): void => openOffers?.();
